import { baseAxios } from "./Axios";
//Components
import { SoundButton, SoundStopAll } from "../components/Sounds";


const requestQuestion = async(body)=>{
    const response = await baseAxios.post('/checkpoint', body);
    return response;
}

const requestProccessAnswers = async()=>{
    const categorie = localStorage.getItem('categorie');
    const response = await baseAxios.get(`/checkpoint-all?category=${categorie ? categorie : 'Aficionado'}`)
    return response;
}

const saveAllQuestions = () => {
    //Send all answers
    requestProccessAnswers()
        .then((res)=>{
            const { data } = res;
            localStorage.setItem('answers', JSON.stringify(data));
            document.querySelector('.loader').classList.remove('disabled')
            setTimeout(()=>{
                location.reload();
            },1000);
        }).catch(err=>{
            console.log(err);
        });
}

const SaveQuestion = ()=>{
    const questions = document.querySelectorAll('#render-questions input');
    const buttons = document.querySelectorAll('#render-questions .block .btn');

    //Enable first question
    questions[0] && questions[0].closest('.block').classList.add('active');

    //get info answer
    questions.forEach((question)=>{
        question.addEventListener('click', ()=>{
            const currentButtonEnable = document.querySelector('#render-questions .block.active .btn');
            const id = question.id;
            currentButtonEnable.dataset.answer = id;
            currentButtonEnable.classList.remove('disabled-trivia');
        });
    });

    //Send question
    buttons.forEach((button, indice)=>{
        button.addEventListener('click', ()=>{
            const questions = JSON.parse(localStorage.getItem('questions'));
            const parent = button.closest('.block');
            const formdata = new FormData();
            const parseTime = parseInt(button.dataset.time);
            formdata.append("id", button.dataset.question);
            formdata.append("answer", button.dataset.answer);
            formdata.append("time", parseTime);
            button.classList.add('hidden');
            //Set state to question
            const questionsCopy = [...questions];
            const question = questionsCopy.findIndex(question => question.id === button.dataset.question);
            questionsCopy[question].state = false;
            localStorage.setItem('questions', JSON.stringify(questionsCopy));
            //Send question to endpoint
            if(button.dataset.answer){
                requestQuestion(formdata).then((res)=>{
                    //Disable current question and enable next question
                    if(parent.nextElementSibling){
                        parent && parent.classList.remove('active');
                        parent.nextElementSibling.classList.add('active');
                    }else{
                        saveAllQuestions();
                        SoundStopAll();
                    }
                }).catch((err)=>{
                    console.log(err);
                });
            }else{
                if(!parent.nextElementSibling){
                    console.log('entra');
                    saveAllQuestions();
                    SoundStopAll();
                }else{
                    parent && parent.classList.remove('active');
                    parent.nextElementSibling.classList.add('active');
                }
            }

        });
    });
    //Sounds
    SoundButton();

}

export { SaveQuestion, saveAllQuestions }